import { API_BASE_URL } from './config';
import type { ClinicInfo, WorkingHours, SocialMedia, EmergencyContact } from '@/types/cms';

const SETTINGS_API_URL = `${API_BASE_URL}/settings`;

export interface LegalSection {
  title: string;
  title_en?: string;
  content: string;
  content_en?: string;
}

export interface SystemSettingsContent {
  id?: string;
  clinic_name: string;
  clinic_name_en?: string;
  phone: string;
  email: string;
  whatsapp: string;
  address: string;
  address_en?: string;
  working_hours?: Record<string, any>;
  maintenance_mode: boolean;
  seo?: Record<string, any>;
  pixels?: Record<string, any>;
  chatbot?: Record<string, any>;
  ai?: Record<string, any>;
  appearance?: Record<string, any>;
  terms?: string;
  terms_en?: string;
  privacy?: string;
  privacy_en?: string;
  terms_sections?: LegalSection[];
  privacy_sections?: LegalSection[];
  security?: Record<string, any>;
}

export async function getSettings(): Promise<SystemSettingsContent> {
  const res = await fetch(`${SETTINGS_API_URL}/`);
  if (!res.ok) throw new Error("Failed to fetch settings");
  return res.json();
}

export async function updateSettings(data: SystemSettingsContent, token: string): Promise<SystemSettingsContent> {
  const res = await fetch(`${SETTINGS_API_URL}/`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
    },
    body: JSON.stringify(data),
  });

  if (res.status === 401) {
    window.dispatchEvent(new CustomEvent("auth-error"));
    throw new Error("انتهت جلسة الدخول");
  }

  if (!res.ok) throw new Error("Failed to update settings");
  return res.json();
}
